
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  renderedScenes.push(scene)
  var n1Child = []
  var n2Child = []
  var n3Child = []
  var n4Child = []
  n4Child = n4Child.concat(text(scene._name || this.t('.untitled')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'card-header-title'},{name:'class', val: 'name'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n4 = h('div', props, n4Child)
  n3Child.push(n4)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'card-header'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n3 = h('header', props, n3Child)
  n2Child.push(n3)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'scene'},{name:'class', val: 'card'},{name:'onclick', val: this._sceneClicked.bind(this, scene)},{name:'key', val: scene}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n2 = h('div', props, n2Child)
  n1Child.push(n2)
  var n5Child = []
  var v6 = this._getRelatedScenes(scene)
  Object.keys(v6).forEach(function (k7) {
    var scene = v6[k7]
    if(renderedScenes.indexOf(scene) == -1) {
      n5Child = n5Child.concat(text(renderSceneInFlow.call(this, {scene: scene, renderSceneInFlow: renderSceneInFlow, renderedScenes: renderedScenes})))
    }
  }.bind(this))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'related-scenes'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n5 = h('div', props, n5Child)
  n1Child.push(n5)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'scene-in-flow'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n1 = h('div', props, n1Child)
  n0Child.push(n1)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  